import React from 'react'
import styles from './LocationSelect.module.scss'
import Type from '@/component/Primitive/Type'
import SelectControl from '@/component/Primitive/SelectControl'
import { string, func, array, shape, bool } from 'prop-types'
import cx from 'classnames'

export const LocationSelect = ({
  locations,
  displayedLocation,
  setLocation,
  className,
  disabled,
  disableSelect
}) => {
  if (locations.length === 1) return null
  return (
    <Type
      as="h2"
      size={['body4', 'body3']}
      weight="medium"
      className={cx(
        styles.SelectControlWrapper,
        disabled && styles.disabled,
        className
      )}
    >
      <SelectControl
        name="location"
        className={styles.SelectControl}
        disabled={disabled}
        value={displayedLocation?.vimeoId}
        onChange={(e) => {
          disableSelect()
          setLocation(e.target.value)
        }}
      >
        {!disabled && (
          <>
            {/* <option value="unselected" selected="selected">
              Select a stage
            </option> */}
            {locations.map((l) => (
              <option value={l.vimeoId} key={`State ${l.name}`}>
                {l.name}
              </option>
            ))}
          </>
        )}
        {disabled && <option value="">Loading...</option>}
      </SelectControl>
    </Type>
  )
}

LocationSelect.propTypes = {
  locations: array,
  className: string,
  setLocation: func,
  disabled: bool,
  disableSelect: func,
  displayedLocation: shape({
    name: string,
    vimeoId: string
  })
}
